import swal from 'sweetalert2';

export const handleApiError = async (error, options = {}) => {
    const {
        showAlert = true,
        customTitle = 'Erro',
        customIcon = 'error',
        onClose = null
    } = options;

    let errorMessage = 'Ocorreu um erro inesperado';

    if (typeof error === 'string') {
        errorMessage = error;
    } else if (error?.error) {
        errorMessage = error.error;
    } else if (error?.message) {
        errorMessage = error.message;
    }

    if (showAlert) {
        await swal.fire({
            title: customTitle,
            text: errorMessage,
            icon: customIcon,
            confirmButtonText: 'OK',
            customClass: {
                confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false
        });

        if (onClose) {
            onClose();
        }
    }

    return {
        handled: true,
        message: errorMessage
    };
};

export const safeDispatch = async (store, action, payload, errorOptions = {}) => {
    try {
        return await store.dispatch(action, payload);
    } catch (error) {
        await handleApiError(error, errorOptions);
        return null;
    }
};

export const setupGlobalErrorHandler = (app) => {
    app.config.errorHandler = (err, instance, info) => {
        console.error('Global error:', err);
        console.error('Error info:', info);
    };

    window.addEventListener('unhandledrejection', (event) => {
        event.preventDefault();

        if (event.reason?.handled || event.reason?.intercepted) {
            return;
        }

        console.error('Unhandled promise rejection:', event.reason);
    });
};
